/* global arNextOptions */

(() => {
    const getCookieDomain = () => {
        if (window.arNextOptions && arNextOptions.SITE_ADDRESS) {
            return arNextOptions.SITE_ADDRESS;
        }
        return location.hostname;
    };

    const setCookie = (name, value, options = {}) => {
        let cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

        if (options.path) cookie += `; path=${options.path}`;
        if (options.domain) cookie += `; domain=${options.domain}`;
        if (options.maxAge != null) cookie += `; max-age=${options.maxAge}`;
        if (options.expires instanceof Date) cookie += `; expires=${options.expires.toUTCString()}`;
        if (options.sameSite) cookie += `; samesite=${options.sameSite}`;
        if (options.secure) cookie += '; secure';

        document.cookie = cookie;
    };

    const deleteCookie = (name, domain) => {
        setCookie(name, '', {
            path: '/',
            domain,
            expires: new Date(0),
        });
    };

    document.addEventListener('click', (e) => {
        const link = e.target.closest('.city_item');
        if (!link) return;

        e.preventDefault();

        const regionId = link.getAttribute('data-id');
        const href = link.getAttribute('href') || location.href;
        const domain = getCookieDomain();

        deleteCookie('current_region', domain);
        setCookie('current_region', regionId, {
            path: '/',
            domain,
            sameSite: 'Lax',
            secure: location.protocol === 'https:',
        });

        location.href = href;
    });
})();
